/**
 * Reminder offsets offered by the event editors, shared by web and native.
 *
 * Worth sharing despite being one array: a third, divergent list already exists
 * in native's artifact `RemindersBlock` (it omits 15 and 120 and adds a 0 the
 * event endpoint has no use for), which is exactly the drift this prevents
 * between the two event editors.
 */
export const REMINDER_PRESET_MINUTES = [5, 10, 15, 30, 60, 120, 1440] as const;

/** Google caps overrides at five; the API's zod schema rejects a sixth. */
export const MAX_REMINDERS = 5;
